/* eslint-disable @typescript-eslint/naming-convention */

import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ChangeAccountModal } from '../../../features/auth_v2/components/ChangeAccountModal';
import { useAuthCtx } from '../../../features/auth_v2/hooks/useAuthCtx';
import { TopbarLoginButton } from '../TopbarLoginButton';
import { SearchButtonMobile } from '../NavbarSearch/styles';
import { NavbarContext } from '../NavbarFilters/NavbarContext';
import FolderIcon from '../../../assets/images/icon-folder.svg';
import NotationIcon from '../../../assets/images/icon-notation.svg';
import HelpIcon from '../../../assets/images/icon-help.svg';
import ResetIcon from '../../../assets/images/icon-reset.svg';
import SwapIcon from '../../../assets/images/icon-swap.svg';
import LogoutIcon from '../../../assets/images/icon-logout.svg';
import UsersIcon from '../../../assets/images/icon-users.svg';
import MagnifyingGlassIcon from '../../../assets/images/lupa.svg';
import ChevronIcon from '../../../assets/images/icon-chevron.svg';
import LogoIah from '../../../assets/images/logo-iah.png';
import {
  Icon,
  MenuOptions,
  Navbar,
  NavbarButtons,
  Option,
  Popover,
  ProfileImage,
  ProfileInfo,
  SessionClient,
  SessionName,
  Trigger,
  MagicButton,
  MagicIconContainer,
  MagicTextContainer,
  MagicTitle,
  MagicSubtitle
} from './styles';
import { useSessionInfoStorage } from '../../../features/auth_v2/hooks/useSessionInfoStorage';

export const NavbarUserLogin = () => {
  const history = useHistory();

  const {
    session,
    hasAIAccess,
    aiAccessLoading,
    auth0_token,
    is_authenticated_by,
    logout,
    is_authenticated_with_email,
    go_to_reset_password,
    is_contract_manager
  } = useAuthCtx();

  const [changeAccountVisible, setChangeAccountVisible] = useState(false);

  const ForumAIButton = () => {
    const sessionInfo = useSessionInfoStorage().get();

    if (aiAccessLoading) {
      return (
        <MagicButton
          rel="noopener noreferrer"
          aria-disabled="true"
          style={{ opacity: 0.6, cursor: 'progress', pointerEvents: 'none' }}>
          <MagicTextContainer>
            <img src={LogoIah} alt="IAH Logo" style={{ width: '120px' }} />
            <MagicSubtitle>Verificando acesso…</MagicSubtitle>
          </MagicTextContainer>
        </MagicButton>
      );
    }

    const hasAuthToken = !!auth0_token || !!sessionInfo.sso_token;
    const tokenQuery = auth0_token
      ? `auth0_token=${auth0_token}`
      : `sso_token=${sessionInfo.sso_token}&sso_id=${sessionInfo.sso_id}`;
    const forumIAUrl =
      sessionInfo.client_id &&
      sessionInfo.created_at &&
      hasAuthToken &&
      hasAIAccess
        ? `https://ia.forumconhecimento.com.br/?client_id=${sessionInfo.client_id}&created_at=${sessionInfo.created_at}&${tokenQuery}`
        : 'https://editoraforum.com.br/forum-iah';

    return (
      <MagicButton
        href={forumIAUrl}
        rel="noopener noreferrer"
        target={hasAIAccess ? undefined : '_blank'}>
        <MagicTextContainer>
          <img src={LogoIah} alt="IAH Logo" style={{ width: '120px' }} />
          <MagicSubtitle>Inteligência Artificial</MagicSubtitle>
        </MagicTextContainer>
      </MagicButton>
    );
  };

  const FoldersButton = () => {
    const handleClick = () => history.push('/pastas');

    return (
      <NavbarButtons
        className="one"
        onClick={handleClick}
        style={{ color: '#fff' }}>
        <Icon src={FolderIcon} />
        Pastas
      </NavbarButtons>
    );
  };

  const NotationsButton = () => {
    const handleClick = () => history.push('/anotacoes/1');

    return (
      <NavbarButtons
        className="two"
        onClick={handleClick}
        style={{ color: '#fff' }}>
        <Icon src={NotationIcon} />
        Anotações
      </NavbarButtons>
    );
  };

  const UsersButton = () => history.push('/gestao-usuarios');

  const getName = (str: string) => {
    let [first] = str.split(' ');
    let last = str.split(' ').pop();
    return `${first} ${last}`;
  };

  const getTruncated = (str: string) =>
    str.length > 30 ? `${str.substring(0, 32)}...` : str;

  const menuTitle = (
    <div>
      <ProfileInfo>
        <SessionName>{getName(session.name) || 'Usuário'}</SessionName>
        <SessionClient>{getTruncated(session.client.name)}</SessionClient>
      </ProfileInfo>
      <p style={{}}>
        Logado como <br />
        {session.email}
      </p>
    </div>
  );

  const menuOptions = (
    <MenuOptions>
      <Option target="_blank" href="https://plataformaforum.zendesk.com">
        <Icon src={HelpIcon} alt={HelpIcon} />
        Ajuda
      </Option>
      {is_contract_manager() && (
        <Option onClick={() => UsersButton()}>
          <Icon src={UsersIcon} alt={UsersIcon} />
          Gestão de usuários
        </Option>
      )}
      <Option onClick={() => go_to_reset_password()}>
        <Icon src={ResetIcon} alt={ResetIcon} />
        Redefinir senha
      </Option>
      {is_authenticated_by('auth0') && (
        <Option onClick={() => setChangeAccountVisible(true)}>
          <Icon src={SwapIcon} alt={SwapIcon} />
          Trocar de conta
        </Option>
      )}
      <Option onClick={() => logout()}>
        <Icon src={LogoutIcon} alt={LogoutIcon} />
        Sair
      </Option>
    </MenuOptions>
  );

  const { searchOpen, setSearchOpen } = useContext(NavbarContext);

  const popoverRef = useRef(null);

  return is_authenticated_with_email() ? (
    <>
      <Navbar>
        <SearchButtonMobile onClick={() => setSearchOpen(!searchOpen)}>
          <Icon src={searchOpen ? ChevronIcon : MagnifyingGlassIcon} alt="" />
        </SearchButtonMobile>
        <div id="element-4" className="buttons-wrapper">
          <ForumAIButton />
          <FoldersButton />
          <NotationsButton />
        </div>
        <Popover
          placement="bottom"
          content={menuOptions}
          title={menuTitle}
          trigger="click"
          getPopupContainer={(trigger) => trigger}>
          <Trigger ref={popoverRef}>
            <ProfileImage
              id="element-5"
              title="Menu de usuário"
              src={session.picture}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src =
                  'https://ui-avatars.com/api/?name=' +
                  `${getName(session.name)}` +
                  '&color=fff&background=D7282F';
              }}
            />
          </Trigger>
        </Popover>
      </Navbar>

      {is_authenticated_by('auth0') && (
        <ChangeAccountModal
          {...{
            visible: changeAccountVisible,
            onCancel: () => {
              setChangeAccountVisible(false);
            }
          }}
        />
      )}
    </>
  ) : (
    <TopbarLoginButton />
  );
};
